import React, { useState, useEffect } from 'react';
import FeaturedBeanCard from './FeaturedBeanCard';
import Icon from '../../../components/AppIcon';
import { beansService } from '../../../services/supabaseService';

const FeaturedBeansGrid = ({ language, selectedCountry, searchQuery, selectedProcessing, elevationRange }) => {
  const [beans, setBeans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadBeans();
  }, [selectedCountry, searchQuery, selectedProcessing, elevationRange]);

  const loadBeans = async () => {
    try {
      setLoading(true);
      const filters = {
        isFeatured: true // Only show featured beans
      };

      if (selectedCountry && selectedCountry !== 'all') {
        filters.countryId = selectedCountry;
      }

      if (searchQuery) {
        filters.search = searchQuery;
      }

      if (selectedProcessing) {
        filters.processingType = selectedProcessing;
      }

      if (elevationRange?.min) {
        filters.minElevation = parseInt(elevationRange?.min);
      }

      if (elevationRange?.max) {
        filters.maxElevation = parseInt(elevationRange?.max);
      }

      const data = await beansService?.getAll(filters);
      setBeans(data || []);
    } catch (error) {
      console.error('Failed to load beans:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Icon name="Loader2" size={32} className="animate-spin text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-error/10 border border-error rounded-lg p-6 text-center">
        <Icon name="AlertCircle" size={32} className="mx-auto mb-2 text-error" />
        <p className="text-error">{language === 'en' ? 'Failed to load beans' : '加载失败'}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-heading font-bold text-foreground flex items-center gap-2">
          <Icon name="Star" size={24} className="text-primary" />
          {language === 'en' ? 'Featured Coffee Beans' : '精选咖啡豆'}
        </h2>
        <span className="text-sm text-muted-foreground">
          {beans?.length} {language === 'en' ? 'products' : '个产品'}
        </span>
      </div>
      {beans?.length === 0 ? (
        <div className="bg-muted rounded-lg p-12 text-center">
          <Icon name="Coffee" size={48} className="mx-auto mb-4 text-muted-foreground" />
          <p className="text-lg text-muted-foreground">
            {language === 'en' ? 'No beans available' : '暂无咖啡豆'}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {beans?.map((bean) => (
            <FeaturedBeanCard key={bean?.id} bean={bean} language={language} />
          ))}
        </div>
      )}
    </div>
  );
};

export default FeaturedBeansGrid;